/**
 * created by li si yi
 * 系统设置-业务开关-业务维护
 */
import React, {Component} from 'react';
import {Tabs, Pagination, Switch, Button, message, Popconfirm, Tree, Input} from "antd";
import {Scrollbars} from "react-custom-scrollbars";
import BaseComponent from "../../../base/BaseComponent";
import BaseTable from "../../components/baseTable/BaseTable";
import BusinessSwitch from './component/BusinessSwitch'
import AddAndInfoModal from "./component/AddAndInfoModal";
import DeptSelectModal from "../organizationalStructure/dept/deptSelectModal/DeptSelectModal";
import MenuAndPermissionSelect from "../organizationalStructure/menu/menuAndPermissionSelect/MenuAndPermissionSelect";
import TreeAndTableLayout from "../../../components/TreeAndTableLayout/TreeAndTableLayout";
import {generateTreeData, treeForEach} from "../../../utils";
import BindServiceModal from "./component/BindServiceModal";
import {HEADER_HEIGHT} from "../../../constants";

const {TabPane} = Tabs;
const {Search} = Input;
let height = window.innerHeight - 70;
const ellipsisSty = {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
};
export default class SystemSetup extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            selectedKeys: [],
            tabBarList: [
                {
                    key: '0',
                    name: '部门业务开关',
                },
                {
                    key: '1',
                    name: '业务维护',
                    status: '0'
                }
            ],// 选项卡数据
            switchColumns: [
                {
                    title: '部门名称',
                    dataIndex: 'name',
                    ellipsis: true,
                    key: 'name',
                    width: 150,
                    render: (text) => {
                        return (
                            <div style={ellipsisSty}>{text ? text : ""}</div>
                        )
                    }
                },
                {
                    title: '上级部门',
                    dataIndex: 'fDept',
                    ellipsis: true,
                    width: 150,
                    key: 'fDept',
                    render: (text, record) => {
                        return (
                            <span
                                style={ellipsisSty}>{this.state.superiorDept ? this.state.superiorDept : ""}</span>
                        )
                    }
                },
                {
                    title: '已开启业务',
                    dataIndex: 'deptSwitch',
                    ellipsis: true,
                    key: 'deptSwitch',
                    render: (text, record) => {
                        return (
                            <div style={ellipsisSty}>
                                {text ? text.join("、") : ""}
                            </div>
                        )
                    }
                },
                {
                    title: '操作',
                    dataIndex: 'action',
                    width: 150,
                    key: 'action',
                    render: (text, record) => {
                        return (
                            <div style={{color: this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3"), cursor: 'pointer'}}
                                 onClick={() => {
                                     this.state.currentClickDept = record;
                                     this.businessSwitch(record);
                                 }}
                            >业务开关</div>
                        )
                    }
                },
            ],// 业务开关
            maintainColumns: [
                {
                    title: '业务',
                    dataIndex: 'name',
                    key: 'name',
                    ellipsis: true,
                    width: 200,
                    render: (text) => {
                        return (
                            <div style={ellipsisSty}>{text ? text : ""}</div>
                        )
                    }
                },
                {
                    title: '编码',
                    dataIndex: 'code',
                    width: 200,
                    ellipsis: true,
                    key: 'code',
                    render: (text) => {
                        return (
                            <span style={ellipsisSty}>{text ? text : ""}</span>
                        )
                    }
                },
                {
                    title: '描述',
                    dataIndex: 'desc',
                    ellipsis: true,
                    width: 400,
                    key: 'desc',
                    render: (text) => {
                        return (
                            <div style={ellipsisSty}>
                                {text ? text : ""}
                            </div>
                        )
                    }
                },
                {
                    title: '操作',
                    dataIndex: 'action',
                    ellipsis: true,
                    width: 250,
                    key: 'action',
                    render: (text, record) => {
                        return (
                            <div style={{color:this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3")}}>
                                <span style={{cursor: 'pointer', marginRight: 10}}
                                ><DeptSelectModal
                                    value={record.deptIds || []}
                                    handleOk={data => {
                                        this.bindDept(record.id, data);
                                        console.log('deptId', data)
                                    }}
                                    defaultBtnType={'textBtn'}
                                    checkStrictly={true}
                                    placeholder={"请选择部门"}
                                    onItemDelete={() => {
                                    }}
                                    multiple={true}
                                    treeCheckable={true}
                                    isSystemSetup={true}// 判断刚进页面时调不调接口，项目设置这里不需要刚进页面调
                                /></span>
                                <span style={{cursor: 'pointer', marginRight: 10}}
                                      onClick={(e) => {
                                          this.setState({
                                              menuEditVisible: true,
                                              currentClickData: {
                                                  ...record,
                                                  menuCods: record.menuCodes
                                              },
                                          })
                                      }}
                                >绑定菜单</span>
                                <span style={{cursor: 'pointer', marginRight: 10}}
                                      onClick={(e) => {
                                          this.BindServiceModal.setCheckedList(record.bindServiceNames || []);
                                          this.setState({
                                              bindServiceVisible: true,
                                              currentClickData: {
                                                  ...record,
                                                  // menuCods: record.menuCodes
                                              },
                                          })
                                      }}
                                >绑定服务</span>
                                {/*<span className="cm-link margin-right-15" onClick={()=>showMenuEdit(data)}>绑定菜单</span>*/}
                                <span style={{cursor: 'pointer', marginRight: 10}}
                                      onClick={(e) => {
                                          console.log(this.AddAndInfoModal);
                                          this.addBusiness(record)
                                      }
                                      }>编辑</span>
                                <Popconfirm
                                    title="确定要删除吗?"
                                    // onCancel={this.cancel}
                                    okText="确定"
                                    cancelText="取消"
                                    onConfirm={(e) => {
                                        this.removeBusiness(record.id);
                                        this.confirm();
                                    }}
                                >
                                    <span style={{cursor: 'pointer'}}>删除</span>
                                </Popconfirm>
                            </div>
                        )
                    },
                }
            ],// 业务维护
            thisTabKey: '0',// 选项卡当前选中项
            params1: {
                page: 1,
                size: 10,
                id: "0",
                nameOrCode: '',
            },
            params2: {
                pageNum: 1,
                pageSize: 10,
                name: "",
            },
            total1: 0,
            total2: 0,
            switchDataSource: [],// 业务开关表格数据
            maintainDataSource: [],// 业务维护表格数据
            treeData: [],// 树数据
            treeDataIndex: {// 树组件
                id: "id",
                title: "name",
                children: "child",
                key: "id"
            },
            childrenDataSource: [],// 弹窗数据
            childrenColumns: [
                {
                    title: '业务',
                    dataIndex: 'name',
                    ellipsis: true,
                    key: 'name',
                    width: 150,
                    render: (text) => {
                        return (
                            // <div style={{display: 'flex'}} title={text}>
                            <div style={ellipsisSty}>{text}</div>
                            // </div>
                        )
                    }
                },
                {
                    title: '描述',
                    dataIndex: 'desc',
                    ellipsis: true,
                    // width: '600px',
                    key: 'desc',
                    render: (text) => {
                        return (
                            <div style={ellipsisSty}>
                                {text}
                            </div>
                        )
                    }
                },
                {
                    title: '操作',
                    dataIndex: 'action',
                    ellipsis: true,
                    width: '100px',
                    key: 'action',
                    render: (text, record) => {
                        return (
                            <div>
                                <Switch defaultChecked
                                        checked={this.state.bindModuleBusiness.indexOf(record.code) > -1 ? true : false}
                                        onChange={(checked, e) => {//checked={}
                                            this.businessSwitchItem(record, checked);
                                        }}/>
                            </div>
                        )
                    }
                },
            ],
            checkedKeys: [],
            expandedKeys: [],
            menuEditVisible: false,
            currentClickData: {},// 业务维护
            currentClickDept: {},// 业务开关
            editRole: null,
            autoExpandParent: true,
            bindModuleBusiness: [],// 返回开启的业务按钮
            bindServiceVisible: false,//绑定服务开关
            superiorDept: "",//上级部门
        };
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.getDeptTree();
        this.getDeptAndOpenSwitch();
    }

    componentWillUnmount() {
    }

    render() {
        let {childrenDataSource, childrenColumns, bindModuleBusiness, currentClickDept} = this.state
        return (
            <div className="card-container" style={{marginTop: '15px', marginLeft: '15px'}}>
                {/*选项卡*/}
                {this.renderTabBar()}
                <div style={{display: 'flex'}}>
                    {/*左侧树结构*/}
                    {this.renderTree()}
                    {/*内容*/}
                    {this.renderTable()}
                </div>
                {/*业务开关弹窗*/}
                <BusinessSwitch
                    ref={(e) => {
                        this.BusinessSwitch = e
                    }}
                    getDeptAndOpenSwitch={this.getDeptAndOpenSwitch}
                    dataSource={childrenDataSource}
                    columns={childrenColumns}
                    bindModuleBusiness={bindModuleBusiness}
                    currentClickDept={currentClickDept}>
                </BusinessSwitch>
                <AddAndInfoModal ref={(e) => this.AddAndInfoModal = e}/>
                <MenuAndPermissionSelect
                    visible={this.state.menuEditVisible}
                    data={this.state.currentClickData}
                    handleCancel={this.hideMenuEdit}
                    handleOk={this.submitMenuEdit}
                />
                <BindServiceModal
                    visible={this.state.bindServiceVisible}
                    data={this.state.currentClickData}
                    handleCancel={this.hideServiceEdit}
                    handleOk={this.submitServiceEdit}
                    ref={(BindServiceModal) => {
                        this.BindServiceModal = BindServiceModal
                    }}
                />
            </div>
        )
    }

    // 左侧栏
    renderTree = () => {
        const {
            thisTabKey,
            treeData,
            selectedKeys,
            expandedKeys,
            autoExpandParent,
        } = this.state;
        return (
            thisTabKey == 0 ?
                <div className="TreeAndTableLayout-left sysTree"
                     style={{
                         width: '260px',
                         background: '#fff',
                         marginRight: 1,
                         height: 'calc(100vh - 115px)',
                         borderBottomLeftRidius: '5px'
                     }}>
                    <TreeAndTableLayout
                        style={{width: '260px', height: "calc(100vh - 100px)"}}
                        showSearch={false}
                        treeData={treeData}
                        onSelect={(selectKeys, node) => this.onTreeSelect(selectKeys, node)}
                        onExpand={this.onExpand}
                        showIcon={true}
                        selectedKeys={selectedKeys}
                        expandedKeys={expandedKeys}
                        autoExpandParent={autoExpandParent}
                        defaultLayout={"systemSetupDeptTree"}
                    />
                    <style>{`
                    .sysTree #CmTree .tree-wrap{
                     width:220px;
                    }
                    .sysTree{
                     height:calc(95vh - 93px) !important;
                     border-bottom-left-radius:5px;
                    }
                    .sysTree #TreeAndTableLayout .TreeAndTableLayout-left{
                     width:80%;
                     background-color:rgba(0,0,0,0);
                     border-right:none;
                     }
                     .sysTree #TreeAndTableLayout .TreeAndTableLayout-left {
                       height: calc(96vh - 108px) !important;
                      }
                    `}</style>
                </div> : null
        )
    };
    // 选项卡
    renderTabBar = () => {
        return (
            <Tabs type="card" onChange={this.changeTabBar} style={{fontSize: 16}}>
                {
                    this.state.tabBarList.map((item) => {
                        return (
                            <TabPane tab={item.name} key={item.key} style={{backgroundColor: '#fff'}}/>
                        )
                    })
                }
            </Tabs>
        )
    };
    // 内容
    renderTable = () => {
        let {thisTabKey, switchDataSource, maintainDataSource, switchColumns, maintainColumns, params1} = this.state;
        let tableHeight = window.innerHeight - HEADER_HEIGHT  - 20 - 77 - 15 - 15;
        let heightStyle = thisTabKey == 0 ? {height:  'calc(100vh - 294px)'} : { maxHeight: 'calc(100vh - 229px)'}
        return (
            <div className={'createBtn'} style={{
                backgroundColor: '#fff',
                width: '100%',
                // height: 'calc(93vh - 74px)',
                maxHeight:'calc(100vh - 100px)',
                borderBottomRightRadius: '5px',
                borderBottomLeftRadius: '5px'
            }}>
                {
                    thisTabKey == 0 ? <Search
                        placeholder="请输入部门名称"
                        value={params1.nameOrCode}
                        onChange={(e) => {
                            this.setData('nameOrCode', e.target.value)
                        }}
                        allowClear={true}
                        onSearch={value => {
                            this.setState({
                                params1: {
                                    ...this.state.params1,
                                    nameOrCode: value,
                                }
                            });
                            this.getDeptAndOpenSwitch()
                        }}
                        style={{width: 200, margin: '24px 0px 0px 32px'}}
                    /> : null
                }
                <style>{`
                .createBtn .ant-table-placeholder {
                    // height: 555px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                `}</style>
                <div style={{
                    padding: '24px 32px', borderBottomRightRadius: '5px', borderBottomLeftRadius: `${thisTabKey == 1 ? '5px' : "0px"}`, ...heightStyle,
                }}>
                    {
                        thisTabKey == 1 ?
                            <Button style={{background: this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3"), marginBottom: 24}}
                                    onClick={() => {
                                        this.addBusiness({})
                                    }}
                            >新建业务</Button> : null
                    }
                    <style>
                        {`
                        .createBtn .ant-btn{
                            color:#fff !important;
                            padding:0 8px;
                        }
                        `}
                    </style>
                    <Scrollbars autoHeightMax={`${thisTabKey === "0" ? 'calc(100vh - 342px)' : "calc(100vh - 333px )"}`}
                                autoHeight
                                autoHide>
                        <BaseTable rowKey="id" dataSource={thisTabKey === "0" ? switchDataSource : maintainDataSource}
                                   columns={thisTabKey === "0" ? switchColumns : maintainColumns}
                                   pagination={false}/>
                    </Scrollbars>
                </div>
                {/*分页*/}
                {thisTabKey === "0" && switchDataSource.length ? this.renderFooter() : null}
                {thisTabKey === "1" && maintainDataSource.length ? this.renderFooter() : null}
            </div>
        )
    };
    // 分页
    renderFooter = () => {
        let {thisTabKey, params1, params2, total1, total2} = this.state;
        let {page, size} = params1;
        let {pageNum, pageSize} = params2;
        return (
            <div className={'pagination'}
            // marginTop: `${thisTabKey === "0" ? '-10px' : "46px"}`
                style={{ borderBottomLeftRadius: '5px',padding: "28px 22px"}}>
                <div style={{marginRight: '5px'}}>共 {thisTabKey === "0" ? total1 : total2} 条</div>
                <Pagination
                    showSizeChanger
                    current={thisTabKey === "0" ? page : pageNum}
                    pageSize={thisTabKey === "0" ? size : pageSize}
                    total={thisTabKey === "0" ? total1 : total2}
                    showQuickJumper={true}
                    onChange={this.pageChange}
                    onShowSizeChange={this.pageChange}
                />
            </div>
        )
    };

    setData(key, val) {
        this.state.params1[key] = val;
        this.setState({
            params1: {
                ...this.state.params1,
                nameOrCode: val
            }
        });
        if (!val) {
            this.getDeptAndOpenSwitch(val)
        }
    }

    hideMenuEdit = () => {
        this.setState({
            editRole: null,
            menuEditVisible: false
        });
    };
    hideServiceEdit = () => {
        this.setState({
            editRole: null,
            bindServiceVisible: false
        });
    };
    submitMenuEdit = ({menuCods, permissionCodes}) => {
        console.log(menuCods, permissionCodes)
        message.destroy();
        if (!menuCods.length) {
            return message.error("请选择角色菜单！");
        }
        this.bindMenuAndPermission(menuCods, permissionCodes)
    };
    submitServiceEdit = (list) => {
        // console.log(list);
        message.destroy();
        // if (!list.length) {
        //     return message.error("请选择服务！");
        // }
        let params = {
            id: this.state.currentClickData.id,
            bindServiceNames: list,
        };
        this.request({
            url: "/cm-sites-sys/businessModule/bindMenueAndPermission",
            method: 'post',
            contentType: 'json',
            body: params,
            callBack: (res) => {
                if (res) {
                    this.hideServiceEdit();
                    this.getfindByCondition();
                    this.BindServiceModal.setCheckedList([]);
                    message.success("绑定服务成功");
                } else {
                    message.error("绑定服务失败！");
                }
            },
            errorCallBack: (e) => {
                console.log(e)
            }
        });
    };
    // 绑定菜单
    bindMenuAndPermission = (menuCods, permissionCodes) => {
        let params = {
            id: this.state.currentClickData.id,
            menuCodes: menuCods,
            permissionCodes: permissionCodes
        };
        this.request({
            url: "/cm-sites-sys/businessModule/bindMenueAndPermission",
            method: 'post',
            contentType: 'json',
            body: params,
            callBack: (res) => {
                if (res) {
                    this.hideMenuEdit();
                    this.getfindByCondition();
                    message.success("绑定菜单成功");
                } else {
                    message.error("绑定菜单失败！");
                }
            },
            errorCallBack: (e) => {
                console.log(e)
            }
        });
    };
    // 请求树数据
    getDeptTree = () => {
        const {selectedKeys} = this.state;
        this.deptGetTreeRequest(res => {
            // 格式化树数据
            const treeData = generateTreeData([res], this.state.treeDataIndex);
            const expandedKeys = [];
            // 首次请求设置激活的树id  并展开所有的树
            if (!selectedKeys.length) {
                treeData.forEach(item => {
                    // console.log(item);
                    expandedKeys.push(item.id);
                });
                // treeForEach(treeData, node => {
                //     if (node.children && node.children.length) {
                //         expandedKeys.push(node.id);
                //     }
                // });
                this.setState({
                    selectedKeys: [treeData[0].id],
                    expandedKeys,
                    treeData,
                    superiorDept:treeData[0].title
                },()=>{
                    console.log(this.state.treeData)
                });
            }
            this.setState({
                treeData
            });
        });
    };
    /**
     * 获取部门树
     * @param callBack
     */
    deptGetTreeRequest = (callBack) => {
        this.request({
            url: "/cm-sites-sys/dept/getTree",
            body: {id: 0},
            callBack
        });
    };
    // 获取业务开关表格数据
    getDeptAndOpenSwitch = () => {
        let {params1} = this.state;
        this.request({
            url: "/cm-sites-sys/deptBusinessSwitch/findDetpAndOpenSwitch",
            method: 'post',
            contentType: 'json',
            body: params1,
            callBack: (res) => {
                let total1 = 0;
                let switchDataSource = [];
                if (res) {
                    switchDataSource = res.data;
                    total1 = res.count;
                } else {
                    message.error("数据获取失败！");
                }
                this.setState({total1, switchDataSource});
            },
            errorCallBack: (e) => {
                console.log(e)
            }
        });
    };
    // 业务维护表格数据
    getfindByCondition = () => {
        let {params2} = this.state;
        this.request({
            url: "/cm-sites-sys/businessModule/findByCondition",
            method: 'post',
            body: params2,
            callBack: (res) => {
                let total2 = 0;
                let maintainDataSource = [];
                if (res && res.data) {
                    maintainDataSource = res.data;
                    total2 = res.count;
                } else {
                    message.error("数据获取失败！");
                }
                this.setState({total2, maintainDataSource});
            },
            errorCallBack: (e) => {
                console.log(e)
            }
        })
    };
    // 获取当前部门业务集合
    getDeptSwitchList = (id) => {
        let params = {
            deptId: id,
        };
        let childrenDataSource = [];
        let bindModuleBusiness = [];
        this.request({
            url: "/cm-sites-sys/businessModule/getAllBusinessModulesAndBindCode",
            method: 'post',
            contentType: 'form-data',
            body: params,
            callBack: (res) => {
                console.log("===============", res);
                if (res) {
                    childrenDataSource = res.moduleBusiness;
                    bindModuleBusiness = res.bindModuleBusiness;// 弹窗数据
                }
                this.setState({childrenDataSource, bindModuleBusiness});
            },
            errorCallBack: (e) => {
                console.log(e)
            }
        })
    };
    // 更新开关按钮状态
    updateBusinessSwitch = () => {
        let params = {
            deptId: this.state.currentClickDept.id,
            businessModuleCode: this.state.bindModuleBusiness,// 绑定的业务合集
        };
        this.request({
            url: "/cm-sites-sys/deptBusinessSwitch/upsert",
            method: 'post',
            contentType: 'json',
            body: params,
            callBack: (res) => {
                console.log("===============", res);
                // let childrenDataSource = [];
                // this.setState({childrenDataSource});
            },
            errorCallBack: (e) => {
                console.log(e)
            }
        })
    };
    // 绑定部门
    bindDept = (id, data) => {
        let params = {
            id: id,
            deptIds: data,
        };
        this.request({
            url: "/cm-sites-sys/businessModule/bindDept",
            method: 'post',
            contentType: 'json',
            body: params,
            callBack: (res) => {
                if (res) {
                    message.success("绑定部门成功")
                    this.getfindByCondition()
                }
            },
            errorCallBack: (e) => {
                console.log(e)
            }
        })
    };
    // 删除
    removeBusiness = (id) => {
        let params = {
            id,
        };
        this.request({
            url: "/cm-sites-sys/businessModule/remove",
            method: 'post',
            body: params,
            callBack: (res) => {
                console.log(res);
                // this.setState({});
                this.getfindByCondition()
            },
            errorCallBack: (e) => {
                console.log(e)
            },
        });
    };
    // 选项卡改变
    changeTabBar = (key) => {
        let {tabBarList} = this.state;
        let thisTabBar = tabBarList.find(item => item.key == key)
        this.state.thisTabKey = key;
        this.state.params1.nameOrCode = "";
        if (thisTabBar.key == 0) {
            this.getDeptAndOpenSwitch();
        } else {
            this.getfindByCondition();
        }
    };
    // 分页改变
    pageChange = (page, size) => {
        let {params1, params2, thisTabKey} = this.state;
        if (thisTabKey == 0) {
            params1.page = page;
            params1.size = size;
            this.getDeptAndOpenSwitch();
        } else {
            params2.pageNum = page;
            params2.pageSize = size;
            this.getfindByCondition();
        }
    };
    onCheck = checkedKeys => {
        this.setState({
            checkedKeys
        });
    };
    onSelect = (keys, event) => {
        console.log('Trigger Select', keys, event);
    };
    // 删除
    confirm = (e) => {
        console.log(e);
        message.success('业务删除成功');
    };

    // 添加业务
    addBusiness(record) {
        this.AddAndInfoModal.showModal({
            item: record, callBack: () => {
                this.getfindByCondition();
            }
        });
    };

    // 业务开关
    businessSwitch = (record) => {
        // console.log(record);
        this.getDeptSwitchList(record.id);
        this.BusinessSwitch.showModal({
            item: record, callBack: () => {
                this.getDeptAndOpenSwitch();
            }
        });
    };

    // 当前部门业务开关按钮集合
    businessSwitchItem(record, checked) {
        if (checked) {
            if (this.state.bindModuleBusiness.indexOf(record.code) == -1) {
                this.state.bindModuleBusiness.push(record.code)
            }
        } else {
            this.state.bindModuleBusiness.forEach((item, index) => {
                if (record.code == item) {
                    this.state.bindModuleBusiness.splice(index, 1)
                }
            });
        }
        this.setState({})
    };

    // 左侧树
    onTreeSelect = (selectKeys, node) => {
        console.log("===========", selectKeys, node);
        this.setState({
            selectedKeys: selectKeys,
            currentPage: 1,
            searchValue: "",
            superiorDept: node.node.props.children && node.node.props.children.length ? node.node.props.dataRef.title : ""
        }, () => {
            this.deptConditionQuery();
        });
        this.state.params1.id = selectKeys.join();
        this.getDeptAndOpenSwitch();
    };
    deptConditionQuery = () => {
        const {pageSize: size, currentPage: page, searchValue: nameOrCode = "", selectedKeys} = this.state;
        const id = selectedKeys[0];
        const params = {
            id, nameOrCode, page, size
        };
        // this.setState({
        //     tableIsLoading: true
        // });
        this.deptConditionQueryRequest(params, res => {
            const {count} = res.data.count;
            if (count !== 0 && count <= (page - 1) * size) {
                this.onPageChange(page - 1, size);
            } else {
                this.setState({
                    tableData: res.data.data,
                    count: res.data.count,
                    tableIsLoading: false
                });
            }

        });
    };
    deptConditionQueryRequest = ({id = "0", nameOrCode, page, size, ifContainSonDept = 1} = {}, callBack) => {
        this.request({
            url: "/cm-sites-sys/dept/getAllChildDeptListBydeptFindPojo",
            body: {id, nameOrCode, page, size, ifContainSonDept},
            method: "post",
            contentType: "json",
            callBack
        });
    };
    onExpand = expandedKeys => {
        this.setState({
            expandedKeys,
            autoExpandParent: false
        });
    };
}
;

SystemSetup.defaultProps = {};
SystemSetup.propTypes = {};